import React, { useState, useEffect, useContext, useRef } from "react";
import "./styles/styles.css";
import "../../styles/global.css";
import EventTitle from "../../components/EventTitle/EventTitle";
import { icons } from "../../constants";
import AccreditationButton from "../../components/AccreditationButton/AccreditationButton";
import AccreditationInput from "../../components/AccreditationInput/AccreditationInput";
import Modal from "../../components/Modal/Modal";
import { registeredTableOptionsFirst } from "../../constants/tables";
import TableFirst from "../../components/TableFirst/TableFirst";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import { useParams } from "react-router-dom";
import { addFieldToObjects } from "../../utils/addFieldToObjects";
import { TranslationsContext } from "../../utils/TranslationsContext";
import { fetchData, downloadFile } from "../../utils/methods";
import { apiRoutes } from "../../utils/apiRoutes";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import { useAlert } from "../../utils/AlertContext";
import { useTheme } from "../../utils/ThemeContext";
import { sortData } from "../../utils/sortData";
import { updateData } from "../../utils/methods";
import ButtonCard from "./components/ButtonCard";
import VehiclesPanel from "./components/VehiclesPanel";
import { sortByCreatedAtIfExists } from "../../utils/sortByCreatedAtIfExists";
import { replaceEventIdWithSlug } from "../../utils/eventUrl";
import ImportPersons from "../../components/Modal/components/ImportPersons";

const EventFirstPage = () => {
  const { t } = useContext(TranslationsContext);
  const { theme } = useTheme();

  // "ne" first: it's the default (DogadjajGrupaKorisnik.notify), and any
  // unrecognized stored value is shown as it too (see selectedOption below).
  const sentOptions = [
    { key: 2, value: "ne", label: t("DO_NOT_SEND") },
    { key: 1, value: "korisniku", label: t("SEND_TO_ME") },
    { key: 3, value: "osobi", label: t("SEND_TO_PERSON") },
  ];
  const [searchValue, setSearchValue] = useState("");
  const [addPersonOpen, setAddPersonOpen] = useState(false);
  const [importPersonsOpen, setImportPersonsOpen] = useState(false);
  const [editPersonOpen, setEditPersonOpen] = useState(false);
  const [editPersonObject, setEditPersonObject] = useState({});
  const [openAddVehicleModal, setOpenAddVehicleModal] = useState(false);
  const [editVehicleModalOpen, setEditVehicleModalOpen] = useState(false);
  const [editVehicleObject, setEditVehicleObject] = useState(null);
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const [sendAll, setSendAll] = useState();
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const [event, setEvent] = useState();
  const navigate = useNavigate();
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [dataLength, setDataLength] = useState(0);
  const [persons, setPersons] = useState([]);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { showAlert } = useAlert();
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [selectedStatusOptions, setSelectedStatusOptions] = useState([
    "prijavljen",
    "odbijen",
    "odobren",
    "u_obradi",
  ]);

  // Plain /event/:id vs. the nested /events/:eventId/persons/:personId deep
  // link — only one of `id`/`eventId` is ever populated depending on which
  // route matched, so this works without checking the path directly.
  const params = useParams();
  const routeEventId = params.eventId || params.id;

  // Route came in with the event's id (notification, old link, ...) — show
  // the slug in the address bar instead.
  useEffect(() => {
    if (event && event.id === routeEventId) {
      replaceEventIdWithSlug(routeEventId, event.slug);
    }
  }, [routeEventId, event]);
  const deepLinkPersonId = params.personId || null;
  // The route segment can be the event's slug now, not just its uuid —
  // getDogadjaj resolves either, but every OTHER endpoint (persons,
  // vehicles, ...) filters by the real dogadjajId column, so everything
  // below this point waits for the event fetch and uses its resolved
  // `event.id` rather than the raw route value.
  const id = event?.id || null;

  // Tab state
  const [activeTab, setActiveTab] = useState(
    () => localStorage.getItem("activeTab") || "persons",
  );
  const [vehicles, setVehicles] = useState([]);
  const [vehiclesDataLength, setVehiclesDataLength] = useState(0);

  // Save activeTab to localStorage
  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const result = await fetchData(
          apiRoutes.getEventById.replace(":eventId", routeEventId),
          showAlert,
          navigate,
          t,
        );

        if (!result) return;

        setEvent(result.data);
        setSendAll(result.data.notify);
        console.log("dogadjaj", result.data);
      } catch (err) {
        console.error("Error fetching event:", err);
      }
    };

    fetchEvent();
  }, [routeEventId]);

  useEffect(() => {
    setIsLoadingData(true);
    setIsLoadingMore(true);

    const fetchInitialAndRemainingPersons = async () => {
      try {
        const take = 50;

        const initialResult = await fetchData(
          `${apiRoutes.getPersons}?dogadjajId=${id}&offset=0&take=${take}&orderBy=name&orderDirection=desc`,
          showAlert,
          navigate,
          t,
        );

        if (!initialResult) return;

        const { data: initialData, headers } = initialResult;

        const sortedPersons = sortByCreatedAtIfExists(initialData);

        setPersons(sortedPersons);
        console.log(initialData, "initialData");

        const totalCountHeader = headers.get("x-total-count");
        const totalCount = totalCountHeader ? Number(totalCountHeader) : 0;
        if (totalCountHeader) {
          setDataLength(totalCount);
        }
        setIsLoadingData(false);

        let currentOffset = initialData.length;
        let currentTake = 100;

        // Stop as soon as we've reached the known total instead of always
        // firing one more round-trip to confirm there's nothing left — that
        // extra request (plus the 300ms delay below) is what left the
        // progress bar sitting at 100% for a beat after it was really done.
        while (!totalCount || currentOffset < totalCount) {
          const moreResult = await fetchData(
            `${apiRoutes.getPersons}?dogadjajId=${id}&offset=${currentOffset}&take=${currentTake}&orderBy=name&orderDirection=desc`,
            showAlert,
            navigate,
            t,
          );

          if (
            !moreResult ||
            !Array.isArray(moreResult.data) ||
            moreResult.data.length === 0
          ) {
            break;
          }

          setPersons((prev) => [...prev, ...moreResult.data]);
          currentOffset += moreResult.data.length;
          currentTake *= 2;

          if (totalCount && currentOffset >= totalCount) break;

          await new Promise((res) => setTimeout(res, 300));
        }
      } catch (err) {
        console.error("Error fetching persons:", err);
      } finally {
        setIsLoadingMore(false);
      }
    };

    if (id) fetchInitialAndRemainingPersons();
  }, [id]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const filteredPersons = persons
    .filter((user) =>
      selectedStatusOptions.includes(user.status?.toLowerCase()),
    )
    .map((user) => {
      const Person = { id: user.id, className: "first-registered-user" };
      registeredTableOptionsFirst(t).forEach((option) => {
        if (option.name === "ime") {
          Person[option.name] = `${user.ime} ${user.prezime}`;
        } else {
          Person[option.name] = user[option.name.toLowerCase()] || "";
        }
      });

      Person.accreditation = user.id_akreditacije || "";
      return Person;
    })
    .filter((person) => {
      const q = debouncedSearchValue.toLowerCase();
      return (
        person.ime.toLowerCase().includes(q) ||
        String(person.email || "").toLowerCase().includes(q)
      );
    });

  const getPersonById = (id) => {
    return persons.find((person) => person.id === id);
  };

  // personId param shares a name with the outer `id` (eventId) above, so it
  // gets its own name here to keep both readable in the URL built below.
  const onActionClick = (personId, personOverride, skipNavigate = false) => {
    const selectedPerson = personOverride || getPersonById(personId);
    if (!selectedPerson) return;

    console.log("pronadjena osoba", selectedPerson);

    const person = {
      id: selectedPerson.id,
      slika: selectedPerson.slika,
      ime: selectedPerson.ime,
      prezime: selectedPerson.prezime,
      entitet: selectedPerson.entitet,
      pozicija: selectedPerson.pozicija,
      email: selectedPerson.email,
      grupa: selectedPerson.grupa,
      tip_dokumenta: selectedPerson.tip_dokumenta,
      broj_dokumenta: selectedPerson.broj_dokumenta,
      dogadjajId: selectedPerson.dogadjajId,
      slika_crop: selectedPerson.slika_crop,
      drzavljanstvo: selectedPerson.drzavljanstvo,
      datum_rodjenja: selectedPerson.datum_rodjenja,
      zemlja_izdavanja: selectedPerson.zemlja_izdavanja,
      datum_izdavanja: selectedPerson.datum_izdavanja,
      datum_isteka: selectedPerson.datum_isteka,
      status: selectedPerson.status,
      old_person: selectedPerson,
    };

    setEditPersonObject(person);
    setEditPersonOpen(true);
    // Deep-link opens (skipNavigate) land here with the URL already
    // correct — only row clicks need to push it.
    if (!skipNavigate) {
      navigate(`/events/${event?.slug || id}/persons/${selectedPerson.id}`);
    }
  };

  // /events/:eventId/persons/:personId deep link — open the edit modal for
  // that person as soon as we have their data, without waiting on a row
  // click. Falls back to a direct fetch since the person may not be on the
  // currently loaded page of the (paginated) persons list. Mirrors
  // PersonsPanel.jsx's (Third tier) deep-link handling.
  const deepLinkHandledRef = useRef(false);
  useEffect(() => {
    if (!deepLinkPersonId || deepLinkHandledRef.current) return;
    deepLinkHandledRef.current = true;

    const openDeepLinkedPerson = async () => {
      let selectedPerson = getPersonById(deepLinkPersonId);
      if (!selectedPerson) {
        const result = await fetchData(
          apiRoutes.getPersonById.replace(":personId", deepLinkPersonId),
          showAlert,
          navigate,
          t,
        );
        if (!result) {
          deepLinkHandledRef.current = false;
          return;
        }
        selectedPerson = result.data;
      }
      onActionClick(selectedPerson.id, selectedPerson, true);
    };

    openDeepLinkedPerson();
  }, [deepLinkPersonId, persons]);

  const handleDownloadClick = async (id) => {
    const person = persons.find((p) => p.id === id);
    setIsLoading(true);

    try {
      const response = await downloadFile(
        apiRoutes.downloadAccr.replace(":id", id),
        person?.ime + "_" + person.prezime || "akreditacija",
      );
      console.log("response", response);
      if (response === "error") {
      }
    } catch (error) {
      console.error("Download failed:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const tableHeader = addFieldToObjects(
    registeredTableOptionsFirst(t),
    "class",
    "first-registered-user",
  );

  // const object = {notify: selectedKey ===

  const handleSetSendAll = async (selectedKey) => {
    try {
      const result = await updateData(
        `${apiRoutes?.notify}/${event?.dogadjajGrupaKorisnikId}`,
        { notify: selectedKey },
        showAlert,
        navigate,
        t,
      );
      if (!result) return;

      // console.log("Podaci su uspešno sačuvani:", result.data);
      showAlert(t("SUCCESSFULLY_SAVED"), "success");
      setSendAll(selectedKey);
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      setIsLoading(false);
    }
    console.log(selectedKey, "selectedKey");
  };


  const handleSortChange = (field, direction) => {
    setSortField(field);
    setSortDirection(direction);
  };

  if (isLoading) {
    return <Loader />;
  }

  console.log("event", event);

  const isDeadlinePassed = (obj) => {
    console.log("objekat za proveru datuma: ", obj);
    if (!obj?.prijava_do || !obj?.prijava_od) return false;
    const start = new Date(obj?.prijava_od || null);
    const end = new Date(obj?.prijava_do || null);
    const now = new Date();

    console.log("pocetni, krajnji ", start, end);

    console.log("mow", now >= start && now <= end);
    return now >= start && now <= end;
  };

  return (
    <div className="flex-direction-column gap-12 width-100">
      <div className="flex-direction-column gap-48 justify-between width-100 event-header">
        <EventTitle event={event} t={t} />
      </div>

      {/* Tab Navigation */}
      <div className="flex-direction-row gap-12 width-100 event-buttons-container">
        <div className="flex-direction-row gap-12 width-100 event-buttons-primary">
          <ButtonCard
            title={t("PERSONS_FOR_ACCREDITATION")}
            count={event?.totalObradjeno || 0}
            totalCount={event?.totalOsobe || 0}
            iconActive={icons.event_persons_blue}
            iconInactive={icons.event_persons_grey}
            active={activeTab === "persons"}
            setActiveTab={setActiveTab}
            value="persons"
          />
          <div className="event-buttons-primary-line" />
          <ButtonCard
            title={t("VEHICLES")}
            count={event?.totalVozila || 0}
            iconActive={icons.vehicle}
            iconInactive={icons.vehicle_grey}
            active={activeTab === "vehicles"}
            setActiveTab={setActiveTab}
            value="vehicles"
          />
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === "persons" && (
        <>
          {/* Search and Actions for Persons */}
          <div className="flex-direction-row width-100 justify-between items-end gap-48 event-search-buttons-first">
            <div className="flex-direction-row gap-12 items-center flex-nowrap event-search-input-group">
              <AccreditationInput
                type="search"
                placeholder={t("SEARCH_PLACEHOLDER")}
                setInputValue={(value) => setSearchValue(value)}
                value={searchValue}
                className="justify-end"
              />
              <p
                className={`inria-sans-400 font-12 persons-counter ${
                  isLoadingMore ? "persons-counter--loading" : ""
                }`}
                style={{
                  color: "var(--text-gray)",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                }}
              >
                {filteredPersons.length} / {dataLength}
              </p>
              {isLoadingMore && (
                <ProgressBar
                  value={persons.length}
                  total={dataLength}
                  active={isLoadingMore}
                />
              )}
            </div>
            <div className="flex-direction-column gap-8 event-number-buttons">
              <div className="flex-direction-row gap-8 first-event-buttons">
                {event?.link && (
                  <div className="flex-direction-row gap-12 event-first-copy-wrapper">
                    <div className="flex-direction-row">
                      {" "}
                      <img
                        src={theme === "light" ? icons.link : icons.link_dark}
                        alt="link"
                      />
                      <AccreditationInput
                        className={`event-firs-link-input ${
                          isLinkCopied ? "copy-animation" : ""
                        }`}
                        // disabled
                        value={`${window.location.origin}/press/${event?.link}`}
                      />
                    </div>

                    <AccreditationButton
                      title={t("COPY")}
                      type="save"
                      className={`event-firs-link-btn ${isLinkCopied ? "copy-animation" : ""}`}
                      onClick={() => {
                        navigator.clipboard.writeText(`${window.location.origin}/press/${event?.link}`);
                        setIsLinkCopied(true);
                        setTimeout(() => setIsLinkCopied(false), 600);
                      }}
                    />
                  </div>
                )}
                <AccreditationInput
                  type="dropdown"
                  variant="send-all"
                  selectedOption={
                    (
                      sentOptions.find((option) => option.value === sendAll) ||
                      sentOptions[0]
                    ).label
                  }
                  setSelectedOption={(value) => {
                    const selectedKey = sentOptions.find(
                      (option) => option.key === value,
                    )?.value;
                    handleSetSendAll(selectedKey);
                  }}
                  options={sentOptions.map((option) => ({
                    key: option.key,
                    value: option.label,
                  }))}
                  // value={userObject.tip_dokumenta}
                />
                <div>
                  <AccreditationButton
                    type="add"
                    title={t("ADD_PERSON")}
                    icon={theme == "light" ? icons.add : icons.add_btn_dark}
                    onClick={() => setAddPersonOpen(true)}
                    disabled={event && !isDeadlinePassed(event)}
                    tooltip={
                      event && !isDeadlinePassed(event)
                        ? t("OUTSIDE_REGISTRATION_PERIOD")
                        : null
                    }
                  />
                </div>
                <div>
                  <AccreditationButton
                    type="import"
                    className="import-wide"
                    title={t("IMPORT_PERSONS_BUTTON")}
                    icon={icons.import_icon}
                    onClick={() => setImportPersonsOpen(true)}
                    disabled={!id || (event && !isDeadlinePassed(event))}
                    tooltip={
                      event && !isDeadlinePassed(event)
                        ? t("OUTSIDE_REGISTRATION_PERIOD")
                        : null
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <TableFirst
            options={tableHeader}
            data={sortData(filteredPersons, sortField, sortDirection)}
            onClick={(key) => onActionClick(key)}
            onDownloadClick={(key) => handleDownloadClick(key)}
            t={t}
            isLoadingData={isLoadingData}
            query={debouncedSearchValue}
            sortField={sortField}
            sortDirection={sortDirection}
            onSortChange={handleSortChange}
            setSelectedStatusOptions={setSelectedStatusOptions}
            selectedStatusOptions={selectedStatusOptions}
          />
        </>
      )}

      {activeTab === "vehicles" && event && (
        <VehiclesPanel
          event={event}
          vehicles={vehicles}
          setVehicles={setVehicles}
          vehiclesDataLength={vehiclesDataLength}
          setVehiclesDataLength={setVehiclesDataLength}
          eventId={id}
          isActive={activeTab === "vehicles"}
        />
      )}

      {editPersonOpen && editPersonObject && (
        <Modal
          type="person"
          onCloseClick={() => {
            setEditPersonOpen(false);
            // Prefer the slug so closing doesn't swap a pretty URL the user
            // arrived on for the uuid — falls back to routeEventId for the
            // (rare, pre-slug) event that has none.
            navigate(`/event/${event?.slug || routeEventId}`);
          }}
          object={editPersonObject}
          editing
          handleUpdateData={(updatedPerson) => {
            setPersons(
              persons.map((person) =>
                person.id === updatedPerson.id
                  ? { ...person, ...updatedPerson }
                  : person,
              ),
            );
          }}
          handleDeleteData={(id) => {
            setPersons((prevPersons) =>
              prevPersons.filter((person) => person.id !== id),
            );
            setDataLength(dataLength - 1);
          }}
        />
      )}
      {addPersonOpen && (
        <Modal
          event_id={id}
          type="person"
          onCloseClick={() => {
            setAddPersonOpen(false);
          }}
          handleAddData={(data) => {
            setDataLength(dataLength + 1);
            data.status = "prijavljen";
            setPersons([...persons, data]);
          }}
        />
      )}

      {importPersonsOpen && id && (
        <ImportPersons
          eventId={id}
          onClose={() => setImportPersonsOpen(false)}
          onImported={(imported) => {
            if (!imported.length) return;
            setPersons((prev) => [...imported, ...prev]);
            setDataLength((prev) => prev + imported.length);
          }}
        />
      )}

      {/* Vehicle Modals */}
      {openAddVehicleModal && (
        <Modal
          type="vehicle"
          onCloseClick={() => setOpenAddVehicleModal(false)}
          eventId={id}
          handleAddData={(vehicleData) => {
            setVehicles([...vehicles, vehicleData]);
            setVehiclesDataLength(vehiclesDataLength + 1);
            setOpenAddVehicleModal(false);
          }}
        />
      )}

      {editVehicleModalOpen && editVehicleObject && (
        <Modal
          type="vehicle"
          onCloseClick={() => setEditVehicleModalOpen(false)}
          object={editVehicleObject}
          editing
          eventId={id}
          handleUpdateData={(updatedVehicle) => {
            setVehicles(
              vehicles.map((v) =>
                v.id === updatedVehicle.id ? updatedVehicle : v,
              ),
            );
            setEditVehicleModalOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default EventFirstPage;
